module.exports = __webpack_public_path__ + "static/media/DSCF9660.fe8c0937.jpg";